import { createSlice } from '@reduxjs/toolkit';

import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { FileDashboardState } from './types/FileDashboardState';
import { getFileDashboardMulti, getFileDashboardSingle } from './fileDashboardThunks';

const initialFileDashboardState: FileDashboardState = {
  fileDashboardSingle: {
    employmentReportStatus: {
      isEmploymentReportProcessing: false,
      latestProcessedReportHasDeviationsAndNoPayrollData: null,
      latestProcessedReportHasInformationAndNoPayrollData: null,
    },
    payMonthOverviewsForYear: [],
    isAnyReportProcessingForYear: false,
    payMonthsWithDeviations: null,
    payMonthsWithInformation: null,
    unreportedPayMonths: null,
    expiringFaGroups: null,
    employmentReportWithDeviations: null,
    employmentReportWithInformation: null,
  },
  loadingFileDashboardSingle: ThunkRequestStatus.Pending,
  fileDashboardMulti: {
    fileReportHistoryLog: [],
    openReportingPeriods: [],
  },
  loadingFileDashboardMulti: ThunkRequestStatus.Pending,
};

const fileDashboardSlice = createSlice({
  name: 'fileDashboard',
  initialState: initialFileDashboardState,
  reducers: {},
  extraReducers: builder => {
    // Get data for dashboard content in multi mode
    builder.addCase(getFileDashboardMulti.fulfilled, (state, action) => {
      if (action.payload) {
        state.fileDashboardMulti = action.payload;
        state.loadingFileDashboardMulti = ThunkRequestStatus.Fulfilled;
      }
    });
    builder.addCase(getFileDashboardMulti.pending, state => {
      state.loadingFileDashboardMulti = ThunkRequestStatus.Pending;
    });
    builder.addCase(getFileDashboardMulti.rejected, (state, action) => {
      state.loadingFileDashboardMulti = ThunkRequestStatus.Rejected;
    });

    // Get data for dashboard content in single mode
    builder.addCase(getFileDashboardSingle.fulfilled, (state, action) => {
      if (action.payload) {
        state.fileDashboardSingle = action.payload;
        state.loadingFileDashboardSingle = ThunkRequestStatus.Fulfilled;
      }
    });
    builder.addCase(getFileDashboardSingle.pending, state => {
      state.loadingFileDashboardSingle = ThunkRequestStatus.Pending;
    });
    builder.addCase(getFileDashboardSingle.rejected, state => {
      state.loadingFileDashboardSingle = ThunkRequestStatus.Rejected;
    });
  },
});

// export const {
//  } = fileDashboardSlice.actions;

export const fileDashboardReducer = fileDashboardSlice.reducer;
